import { Component, DestroyRef, computed, inject, signal } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { EMPTY, catchError, distinctUntilChanged, filter, map, startWith, switchMap, tap } from 'rxjs';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { NzAvatarComponent } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { AuditoriaService } from '../../../features/auditoria/services/auditoria.service';
import { I18nService } from '../../../core/i18n/services/i18n.service';
import { SessaoStore } from '../../../core/auth/store/sessao.store';
import { calcularIniciais } from '../../utils/functions-utils';

@Component({
  selector: 'app-top-navigation',
  standalone: true,
  imports: [UpperCasePipe, NzTypographyComponent, NzAvatarComponent, NzButtonModule, RouterLink],
  templateUrl: './top-navigation.component.html',
  styleUrl: './top-navigation.component.scss'
})
export class TopNavigationComponent {
  private readonly router = inject(Router);
  private readonly auditoria = inject(AuditoriaService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly origem = signal<{ codigo: string; registro: string | null }>({ codigo: '', registro: null });
  protected readonly i18n = inject(I18nService);
  protected readonly sessao = inject(SessaoStore);
  protected readonly iniciais = computed(() => calcularIniciais(this.sessao.nomeExibicao()));
  protected readonly atalhoAuditoria = computed(() => {
    const origem = this.origem();
    return this.auditoria.telas().some(tela => tela.codigo === origem.codigo) ? origem : null;
  });
  title = 'SISGestão';

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      startWith(null),
      map(() => {
        // Na primeira carga o componente nasce durante a ativação, quando as ActivatedRoute filhas
        // ainda não têm snapshot; a árvore de snapshots do Router já está completa nesse momento.
        let ativa = this.router.routerState.snapshot.root;
        while (ativa.firstChild) ativa = ativa.firstChild;
        const codigo: unknown = ativa.data['codigoTela'];
        return {
          codigo: typeof codigo === 'string' ? codigo : '',
          registro: ativa.data['auditoriaRepassaRegistro'] === true
            ? ativa.queryParamMap.get('id') : null
        };
      }),
      tap(origem => this.origem.set(origem)),
      map(origem => origem.codigo),
      distinctUntilChanged(),
      switchMap(codigo => codigo ? this.auditoria.carregarTelas().pipe(catchError(() => EMPTY)) : EMPTY),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}
